export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const UPDATE_SESSION = "UPDATE_SESSION";
export const SET_ADMIN_EVENTS = "SET_ADMIN_EVENTS";
export const SET_LIVE_EVENTS = "SET_LIVE_EVENTS";
export const SET_QUOTES = "SET_QUOTES";
export const SET_RECENTLY_BLOCKED = "SET_RECENTLY_BLOCKED";
export const SET_RECENTLY_UNBLOCKED = "SET_RECENTLY_UNBLOCKED";
export const SET_RECENTLY_DELETED = "SET_RECENTLY_DELETED";
